import { render, staticRenderFns } from "./CredentialCard.vue?vue&type=template&id=c0afa9dc&"
import script from "./CredentialCard.vue?vue&type=script&lang=ts&"
export * from "./CredentialCard.vue?vue&type=script&lang=ts&"
import style0 from "./CredentialCard.vue?vue&type=style&index=0&id=c0afa9dc&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports